import React, {useCallback, useState} from "react";
import "./FacilityCarouselComponent.scss"; // Import styles
import {ImageConfig} from "../../../constants";
import {CommonService} from "../../../shared/services";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import FacilityTimingsModalComponent from "./facility-timings-modal/FacilityTimingsModalComponent";
import ServiceCategoryModalComponent from "./service-category-modal/ServiceCategoryModal";
import ProviderDetailsModalComponent from "./provider-details-modal/ProviderDetailsComponent";
import BookAppointmentFlowModalComponent from "./book-appointement-flow-modal/BookAppointmentFlowModalComponent";
import SkeletonCard from "../../../shared/components/skeleton-card/SkeletonCard";

const MAX_VISIBILITY = 2;

interface CardProps {
    facilityProviderDetails?: any;
    active?: any;
    setPaymentSuccessParentConfirmation?: any
}

const FacilityCard = (props: CardProps) => {
    const {facilityProviderDetails, setPaymentSuccessParentConfirmation} = props;
    const [isDayTimingsModalOpen, setIsDayTimingsModalOpen] = useState<boolean>(false);
    const [isServiceCategoryModalOpen, setIsServiceCategoryModalOpen] = useState<boolean>(false);
    const [isProviderDetailsModalOpen, setIsProviderDetailsModalOpen] = useState<boolean>(false);
    const [isBookAppointmentFlowModalOpen, setIsBookAppointmentFlowModalOpen] = useState<boolean>(false);
    const [serviceCategoryDetails, setServiceCategoryDetails] = useState<any>([]);
    const [facilityDetails, setFacilityDetails] = useState<any>([]);
    const [providerDetails, setProviderDetails] = useState<any>([]);
    const [isProviderDetailsLoading, setIsProviderDetailsLoading] = useState<boolean>(false);
    const [isServiceCategoryDetailsLoading, setIsServiceCategoryDetailsLoading] = useState<boolean>(false);
    const [isFacilityDetailsLoading, setIsFacilityDetailsLoading] = useState<boolean>(false);


    //   below are the book-appointment navigation keys stored in Redux
    // "category_selection_screen" | "category_service_selection_screen" | "injury_type_selection_screen" | "time_rate_slot_selection_screen" | "client_type_selection" | "client_form_based_client_type_selection_screen" | "otp_verification_screen" | "booking_appointment_for_screen" | "someone_else_form_screen" | "select_provider_screen" | "select_date_and_time_screen" | "secure_checkout_screen"

    const handleDayTimingsModalClose = useCallback(() => {
        setIsDayTimingsModalOpen(false);
    }, []);

    const handleServiceCategoryModalClose = useCallback(() => {
        setIsServiceCategoryModalOpen(false);
    }, []);

    const handleProviderDetailsModalClose = useCallback(() => {
        setIsProviderDetailsModalOpen(false);
    }, []);

    const handleBookAppointmentFlowModalClose = useCallback(() => {
        setIsBookAppointmentFlowModalOpen(true);
    }, []);

    const fetchFacilityAppointmentDetails = useCallback((facilityId: string) => {
        setIsFacilityDetailsLoading(true);
        let initialFacilityWithProvidersDetails: any = [];
        CommonService._bookAppointment.GetFacilityDetails(facilityId)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialFacilityWithProvidersDetails = response.data;
                }
                setFacilityDetails(initialFacilityWithProvidersDetails);
                setIsFacilityDetailsLoading(false);
            }).catch((error: any) => {
            setFacilityDetails(initialFacilityWithProvidersDetails);
            setIsFacilityDetailsLoading(false);
        })
    }, []);


    const fetchServiceCategoryDetails = useCallback((facilityId: string) => {
        setIsServiceCategoryDetailsLoading(true);
        let initialServiceCategoryDetails: any = [];
        CommonService._bookAppointment.GetServiceCategoryDetails(facilityId)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialServiceCategoryDetails = response.data;
                }
                setServiceCategoryDetails(initialServiceCategoryDetails);
                setIsServiceCategoryDetailsLoading(false);
            }).catch((error: any) => {
            setServiceCategoryDetails(initialServiceCategoryDetails);
            setIsServiceCategoryDetailsLoading(false);
        })
    }, []);

    const fetchProviderDetails = useCallback((providerId: string) => {
        setIsProviderDetailsLoading(true);
        let initialProviderDetails: any = [];
        CommonService._bookAppointment.GetProviderDetails(providerId)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderDetails = response.data;
                }
                setProviderDetails(initialProviderDetails);
                setIsProviderDetailsLoading(false);
            }).catch((error: any) => {
            setProviderDetails(initialProviderDetails);
            setIsProviderDetailsLoading(false);
        })
    }, [])


    return (
        <>
            {/*Timings modal as per week days start*/}
            <ModalComponent
                isOpen={isDayTimingsModalOpen}
                onClose={handleDayTimingsModalClose}
            >
                <div
                    className="book-appointment-modal-container d-flex justify-content-center align-items-center">
                    <FacilityTimingsModalComponent setIsDayTimingsModalOpen={setIsDayTimingsModalOpen}
                                                   facilityDetails={facilityDetails}
                                                   isFacilityDetailsLoading={isFacilityDetailsLoading}
                    />
                </div>
            </ModalComponent>
            {/*Timings modal as per week days ends*/}

            {/*Category Services modal start*/}
            <ModalComponent
                isOpen={isServiceCategoryModalOpen}
                onClose={handleServiceCategoryModalClose}
            >
                <div
                    className="book-appointment-modal-container d-flex justify-content-center align-items-center">
                    <ServiceCategoryModalComponent
                        setIsServiceCategoryModalOpen={setIsServiceCategoryModalOpen}
                        serviceCategoryDetails={serviceCategoryDetails}
                        facilityDetails={facilityDetails}
                        isServiceCategoryDetailsLoading={isServiceCategoryDetailsLoading}
                    />
                </div>
            </ModalComponent>
            {/*Category Services modal ends*/}

            {/*Provider Details modal start*/}
            <ModalComponent
                isOpen={isProviderDetailsModalOpen}
                onClose={handleProviderDetailsModalClose}
            >
                <div
                    className="book-appointment-modal-container d-flex justify-content-center align-items-center">
                    <ProviderDetailsModalComponent
                        setIsProviderDetailsModalOpen={setIsProviderDetailsModalOpen}
                        providerDetails={providerDetails}
                        isProviderDetailsLoading={isProviderDetailsLoading}
                    />
                </div>
            </ModalComponent>
            {/*Provider Details modal end*/}

            {/*Book Appointment Flow modal start*/}
            <ModalComponent isOpen={isBookAppointmentFlowModalOpen}
                            onClose={handleBookAppointmentFlowModalClose}
            >
                <div
                    className="book-appointment-flow-modal-container">
                    {isServiceCategoryDetailsLoading &&
                        <div
                            className={'book-appointment-flow-modal-loading-container d-flex justify-content-center align-items-center'}>
                            <SkeletonCard/>
                        </div>
                    }
                    {!isServiceCategoryDetailsLoading &&
                        <BookAppointmentFlowModalComponent
                            setPaymentSuccessParentConfirmation={setPaymentSuccessParentConfirmation}
                            serviceCategoryDetails={serviceCategoryDetails}
                            facilityDetails={facilityDetails}
                            setIsBookAppointmentFlowModalOpen={setIsBookAppointmentFlowModalOpen}
                            facilityProviderDetails={facilityProviderDetails}
                            fetchProviderDetails={fetchProviderDetails}
                            providerDetails={providerDetails}
                            isProviderDetailsLoading={isProviderDetailsLoading}
                        />
                    }
                </div>
            </ModalComponent>
            {/*Book Appointment Flow modal end*/}

            <div className="card">
                <div className={'facility-details-wrapper'}>
                    <div className={'d-flex'}>
                        <div>
                            <img className={"facility-image"} src={facilityProviderDetails?.image?.url}
                                 alt={"facility_image"}/>
                        </div>
                        <div className={'mrg-left-10 '}>
                            <div className={'facility-details-text-wrapper'}>
                                {facilityProviderDetails?.name}
                            </div>
                            <div className={'facility-details-address-wrapper'}>
                                {CommonService.formatAddressBillAppointment(facilityProviderDetails?.address)}
                            </div>
                            <div className={'underline-text mrg-top-25 cursor-pointer'} onClick={() => {
                                setIsDayTimingsModalOpen(true);
                                fetchFacilityAppointmentDetails(facilityProviderDetails?._id);
                            }}>
                                View Operating Hours
                            </div>
                            <div className={'underline-text mrg-top-5 cursor-pointer'} onClick={() => {
                                setIsServiceCategoryModalOpen(true);
                                fetchServiceCategoryDetails(facilityProviderDetails?._id);
                                fetchFacilityAppointmentDetails(facilityProviderDetails?._id);
                            }}>
                                View Services Offered Here
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'divider-line mrg-top-20 mrg-bottom-20'}/>
                <div>
                    <div className={'book-appointment-general-text'}>
                        Here are the specialists available at this location:
                    </div>
                    <div className="provider-profile-card-container">
                        {facilityProviderDetails && facilityProviderDetails?.providers?.map((provider: any, index: any) => {
                            return (
                                <div className="profile-card mrg-right-10 mrg-top-5">
                                    <img
                                        className="profile-image mrg-bottom-5"
                                        src={(index % 2 === 0) ? ImageConfig.BookAppointmentMaleIcon : ImageConfig.BookAppointmentFemaleIcon}
                                        alt="Profile"
                                    />
                                    <div
                                        className="profile-name mrg-left-10">{provider?.first_name + " " + provider?.last_name}</div>
                                    <div
                                        className="underline-text-ten-font mrg-left-10 mrg-bottom-10 mrg-top-5 cursor-pointer"
                                        onClick={() => {
                                            setIsProviderDetailsModalOpen(true);
                                            fetchProviderDetails(provider?._id)
                                        }}>
                                        View Profile
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className={'d-flex justify-content-center select-location-button'}>
                    <ButtonComponent onClick={() => {
                        setIsBookAppointmentFlowModalOpen(true);
                        fetchServiceCategoryDetails(facilityProviderDetails?._id);
                        fetchFacilityAppointmentDetails(facilityProviderDetails?._id);
                    }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Select this location&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </ButtonComponent>
                </div>
            </div>
        </>
    )
};


interface CarouselProps {
    facilityWithProvidersDetails?: any;
    isFacilityWithProvidersDetailsLoading?: any;
    setPaymentSuccessParentConfirmation?: any
}

const FacilityCarousel: React.FC<CarouselProps> = (props: CarouselProps) => {
    const {
        facilityWithProvidersDetails,
        isFacilityWithProvidersDetailsLoading,
        setPaymentSuccessParentConfirmation
    } = props;
    const [active, setActive] = useState(0);

    const previousDivStyles: React.CSSProperties = {
        cursor: active === 0 ? 'not-allowed' : 'pointer',
        opacity: active === 0 ? 0.6 : 1,
        pointerEvents: active === 0 ? 'none' : 'auto', // Disables interactions when true
    };
    const nextDivStyles: React.CSSProperties = {
        cursor: active === facilityWithProvidersDetails?.length - 1 ? 'not-allowed' : 'pointer',
        opacity: active === facilityWithProvidersDetails?.length - 1 ? 0.6 : 1,
        pointerEvents: active === facilityWithProvidersDetails?.length - 1 ? 'none' : 'auto', // Disables interactions when true
    };

    return (
        <>
            {isFacilityWithProvidersDetailsLoading &&
                <div className={'e-sign-loading d-flex justify-content-center align-items-center mrg-top-100'}>
                    <LoaderComponent size={"xl"} type={"spinner"} color={"success"}/>
                </div>
            }
            <div className="carousel">
                {(!isFacilityWithProvidersDetailsLoading && facilityWithProvidersDetails) && facilityWithProvidersDetails?.map((facilityProviderDetails: any, index: any) => {
                    const offset = (active - index) / 2;
                    const absOffset = Math.abs(active - index) / 2;
                    return (
                        <>
                            <div
                                key={index}
                                className="card-container"
                                style={{
                                    "--active": index === active ? 1 : 0,
                                    "--offset": offset || 0, // ✅ Ensure a default value
                                    "--direction": Math.sign(active - index),
                                    "--abs-offset": absOffset || 0, // ✅ Prevent NaN issues
                                    "pointerEvents": active === index ? "auto" : "none",
                                    "opacity": Math.abs(active - index) >= MAX_VISIBILITY ? "0" : "1",
                                    "display": Math.abs(active - index) > MAX_VISIBILITY ? "none" : "block",
                                } as React.CSSProperties}
                            >
                                <FacilityCard
                                    setPaymentSuccessParentConfirmation={setPaymentSuccessParentConfirmation}
                                    facilityProviderDetails={facilityProviderDetails}
                                    active={active}
                                    key={index + 'facility_card'}
                                />
                            </div>
                        </>
                    )
                })}
            </div>
            {!isFacilityWithProvidersDetailsLoading &&
                <div className="d-flex mrg-top-30">
                    <div>
                        <div className={`d-flex justify-content-center align-items-center`} style={previousDivStyles}>
                            <div className={`${active > 0 ? "cursor-pointer" : ""}}`}
                                 style={previousDivStyles}
                                 onClick={() => active > 0 &&
                                     setActive((i) => i - 1)}
                            >
                                <ImageConfig.BookAppointmentLeft/>
                            </div>
                            <div className={'book-appointment-action-button-text mrg-right-30 mrg-left-5'}>
                                Previous
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="d-flex justify-content-center align-items-center" style={nextDivStyles}>
                            <div className={'book-appointment-action-button-text mrg-right-5'}>
                                Next
                            </div>
                            <div
                                className={`${active < facilityWithProvidersDetails?.length - 1 ? "cursor-pointer" : ""}}`}
                                onClick={() => active < facilityWithProvidersDetails?.length - 1 && setActive((i) => i + 1)}>
                                <ImageConfig.BookAppointmentRight/>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>

    );
};

export {FacilityCarousel, FacilityCard};
